var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProccessing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5248 12.482H27.9286C28.7667 12.482 29.4524 13.1677 29.4524 14.0058V21.9905C29.4524 27.4305 25.6581 30.4781 20.9648 30.4781H8.98762C4.29429 30.4781 0.5 27.4305 0.5 21.9905V8.48958C0.5 3.04958 4.29429 0.00195312 8.98762 0.00195312H15.4486C16.2867 0.00195312 16.9724 0.687667 16.9724 1.52576V5.92957C16.9724 9.541 19.9133 12.482 23.5248 12.482ZM19.0596 0.992292C19.0596 0.12372 20.1415 -0.302927 20.7662 0.321835C22.289 1.84459 24.5759 4.15237 26.5763 6.17099C27.5386 7.142 28.4345 8.0461 29.1472 8.76373C29.7567 9.37325 29.2996 10.3942 28.431 10.3942C26.7091 10.3942 24.6977 10.3942 23.25 10.379C20.9491 10.379 19.0596 8.53516 19.0596 6.3104V0.992292Z",
    fill: "#1080FF",
    fillOpacity: 0.24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1779 26.304C15.5969 26.5631 15.5969 31.744 19.1779 32.0031H27.6503C28.6712 32.0031 29.677 31.6221 30.4236 30.9364C32.9379 28.7421 31.597 24.3536 28.2903 23.9421C27.1017 16.7955 16.7703 19.5078 19.2084 26.3193",
    fill: "#1080FF",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProccessing);
export default __webpack_public_path__ + "static/media/proccessing.8fc018451ff32845b0092effb8b91997.svg";
export { ForwardRef as ReactComponent };